export const DELETE_IMAGE_SUCCESS = 'DELETE_IMAGE_SUCCESS';

export const deleteImageSuccess = ( id: string ) => ({
    type: DELETE_IMAGE_SUCCESS,
    payload: {
        id,
    },
});
